// @file Show feedback nudge if user came from Import page.
// Only show once per wall.
import { resetNudge, trackEventOnlyOnce } from '@@/bits/command_bar'
import environment from '@@/bits/environment'
import { requestIdleCallback } from '@@/bits/request_idle_callback'
import { tryCatch } from '@@/bits/try_catch'

// https://app.commandbar.com/editor/surveys
const GOOGLE_SLIDES_IMPORT_COMPLETED_FEEDBACK_NUDGE_ID = environment === 'production' ? 16307 : 16405

const showFeedbackNudgeAfterCompletedWallImport = async (): Promise<void> => {
  // Only show after 1 second when idle
  await new Promise<void>((r) => requestIdleCallback(r))
  await new Promise((r) => setTimeout(r, 1000))

  const [referrerUrl, error] = tryCatch(() => new URL(document.referrer))
  if (error) {
    // Invalid referrer URL, just ignore it
    return
  }

  if (referrerUrl.hostname === window.location.hostname && referrerUrl.pathname.endsWith('/import')) {
    // Check document source to skip feedback for PDF imports
    const { useTldrawEditor } = await import('@@/vuecomposables/useTldrawEditor')
    const { editor } = useTldrawEditor()

    if (editor == null) {
      // Editor not yet mounted, be conservative and don't show nudge
      return
    }

    const documentMeta = editor.getDocumentSettings().meta

    // This must match `WallImporting::Importer::IMPORT_SOURCE_GOOGLE_SLIDES` in Rails backend
    if (documentMeta?.source === 'google_slides') {
      const { useSurfaceStore } = await import('@@/pinia/surface')
      const surfaceStore = useSurfaceStore()

      // Reset to always start the nudge from the first step
      resetNudge(GOOGLE_SLIDES_IMPORT_COMPLETED_FEEDBACK_NUDGE_ID)
      trackEventOnlyOnce('wallImportCompletedFeedbackNudge', { localStorageKeySuffix: surfaceStore.wallId })
    }
  }
}

export { showFeedbackNudgeAfterCompletedWallImport }
